export default {"src":"/polygon/_next/static/media/solana.2f86986a.svg","height":80,"width":231};